import { Variant } from './variant';
// import { Modifier } from './modifier';
export class OrderItem {
    constructor(order_item) {
        this.id = order_item.id;
        this.order_id = order_item.order_id;
        this.item_id = order_item.item_id;
        this.quantity = order_item.quantity;
        this.item_name = order_item.item_name;
        this.price = order_item.price;
        this.note = order_item.note;
        this.owner_note = order_item.owner_note;
        this.status = order_item.status;
        this.created_at = order_item.created_at;
        this.updated_at = order_item.updated_at;
        this.cancel_reason = order_item.cancel_reason;
        this.item_image = order_item.item_image;
        this.item_variant = order_item.item_variant ? new Variant(order_item.item_variant) : {};
        this.item_modifier = order_item.item_modifier ? this.getItemModifier(order_item.item_modifier) : [];
    }

    getItemModifier(item_modifier) {
        let arr = [];
        for(let i = 0; i < item_modifier.length; i++) {
            arr.push(new Modifier(item_modifier[i]));
        }
        return arr;
    }
}

export class Modifier {
    constructor(modifier) {
        this.id = modifier.id;
        // this.title = modifier.title;
        // this.status = modifier.status;
        // this.created_at = modifier.created_at;
        // this.updated_at = modifier.updated_at;
        this.is_selected = modifier.is_selected;
        this.modifier_name = modifier.name ? modifier.name : modifier.modifier_name;
        this.type = modifier.type;
        this.required = modifier.required;
        this.details = modifier.details ? this.getDetailList(modifier.details) : [];
    }

    getDetailList(detail) {
        let arr = [];
        for(let i = 0; i < detail.length; i++) {
            arr.push(new ModifierOption(detail[i]));
        }
        return arr;
    }
}

class ModifierOption {
    constructor(option) {
        this.id = option.id;
        this.name = option.name;
        this.price = option.price;
    }
}
